import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { SettingsService } from '@app/shared/services/settings/settings.service';

const PREFERRED_COUNTRIES = [{ abbr: 'us', code: '1' }];

@Component({
  standalone: false,
  selector: 'sbnb-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent implements OnInit {
  public preferredCountries: (typeof PREFERRED_COUNTRIES)[0]['abbr'][];
  public emailChangeRequests$ = this.settingsService.getEmailChangeRequests();
  loading: boolean;
  profileForm: UntypedFormGroup;
  profileData: {
    first_name: string;
    last_name: string;
    email: string;
    phone: string;
    picture: string;
  };

  saving: boolean;
  saveStatus: number;

  constructor(
    private fb: UntypedFormBuilder,
    private settingsService: SettingsService,
    private auth: AuthenticationService
  ) { }

  ngOnInit() {
    this.preferredCountries = PREFERRED_COUNTRIES.map((c) => c.abbr);
    this.loading = true;

    this.settingsService.getProfile().subscribe((res) => {
      this.profileData = res;
      this.loading = false;

      this.profileForm.get('firstName').setValue(this.profileData.first_name);
      this.profileForm.get('lastName').setValue(this.profileData.last_name);
      this.profileForm.get('email').setValue(this.profileData.email);
      this.profileForm.get('phone').setValue(this.addDefaultCountryCode(this.profileData.phone));

      // The phone number *might* be invalid
      // Mark the form fields as touched so that errors show immediately
      this.profileForm.markAllAsTouched();
    });

    this.profileForm = this.fb.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      phone: [''],
    });
  }

  onPictureUploadSuccess(event: any) {
    console.log(event);

    if (event.filesUploaded && event.filesUploaded[0]?.url) {
      this.profileData.picture = event.filesUploaded[0].url;
    }
  }

  save() {
    this.saving = true;
    this.saveStatus = 1;

    const payload = {
      first_name: this.profileForm.get('firstName').value,
      last_name: this.profileForm.get('lastName').value,
      email: this.profileForm.get('email').value,
      phone: this.profileForm.get('phone').value,
      picture: this.profileData.picture,
    };

    this.settingsService.saveProfile(payload).subscribe((res) => {
      this.saving = false;

      if (res.error) {
        this.saveStatus = -1;
      } else {
        this.saveStatus = 2;
        // refresh user data
        setTimeout(() => {
          // It takes a second or two for the backend to return the updated data
          this.auth.getUserDetails(true);
          this.emailChangeRequests$ = this.settingsService.getEmailChangeRequests();
          this.saveStatus = null;
        }, 2000);
      }
    });
  }

  // The phone number input defaults to a US country code flag.
  // If we don't have a country code, add the US country code to match the UI.
  private addDefaultCountryCode(phone: string) {
    if (!phone?.length) return;

    return phone[0] !== '+' ? `+${PREFERRED_COUNTRIES[0].code}${phone}` : phone;
  }
}
